import { ReactNode } from 'react';
import { components } from '@api/club/generated';

import { formatName } from '@libs/formatNames';
import { TableCell, TableRow } from '@ui/components/Table';

import styles from './StartList.module.css';

export function ParticipantStartListRow({
  row,
  showGroup,
  showEmail,
  isRcf,
  groupIsRegion,
  highlightedUserId,
  isInTeam,
  renderShieldQuickPeek,
}: {
  row: components['schemas']['PrivateSeedDto'] | components['schemas']['TeamMemberSeedDto'];
  showEmail: boolean;
  showGroup: boolean;
  isRcf: boolean;
  groupIsRegion: boolean;
  highlightedUserId?: string;
  isInTeam: boolean;
  renderShieldQuickPeek?: (userId: string) => ReactNode;
}) {
  const no = ('seedNumber' in row && row.seedNumber) || ('numberInTeam' in row && row.numberInTeam);
  const isManager = Boolean(showEmail);

  return (
    <>
      <TableRow hoverable clickable active={highlightedUserId === row.userId}>
        {isInTeam && <TableCell />}
        <TableCell className={styles.numColumn}>{no}</TableCell>
        <TableCell>
          <div className={styles.playerNameContainer}>
            <div className={styles.playerName}>{formatName(row)}</div>
            {renderShieldQuickPeek?.(row.userId)}
          </div>
        </TableCell>
        {showEmail && <TableCell>{row.email}</TableCell>}
        {showGroup && (
          <TableCell>{groupIsRegion ? row.rcfRegion || row.groupName : row.groupName}</TableCell>
        )}
        {isRcf && (
          <TableCell leftGap>{row.rcfRegion || (groupIsRegion ? row.groupName : null)}</TableCell>
        )}
        {isRcf && isManager && (
          <TableCell leftGap rightGap>
            {row.rcfYearOfBirth}
          </TableCell>
        )}
        <TableCell>{row.rating.value}</TableCell>
      </TableRow>
    </>
  );
}
